import Image from 'assets/backgrounds/approach.jpg';

export const title = 'Methodik — FondsConsult';
export const description =
  'Präzise, unabhängige Empfehlungen durch ganzheitliche Fonds-Analyse und innovative Benchmarking-Methoden.';
export const imageUrl = `${window.location.origin}${Image}`;
export const content = 'business.business';
